import ShippingOptionsCustomerTable, {
  CrmReceiverCustomer,
} from '../ShippingOptionsCustomerTable';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import CrmCustomerListFilter, {
  CrmFilterFormValues,
} from '../CustomerListFilter';
import { Button, Col, Divider, Row } from 'antd';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import { ArrowLeft, ArrowRight } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import {
  CrmCustomerListProps,
  CrmCustomerWithVehicleListResponse,
} from '@/core/domain/crm/CrmList/CrmList.types';
import { SendOptionType } from '@/core/domain/crm/SendOptions/SendOptions.types';
import { useQueryParams } from '@/hooks/useQueryParams';
import { queryHooks } from './queryHooks';
import { useWindowSize } from '@/hooks';

const CrmCustomersWithVehicleList: React.FC<CrmCustomerListProps> = ({
  onPrev,
  onCustomersSelected,
  customerIds,
  CustomersSelected,
}) => {
  const [filter, setFilter] = useState<CrmFilterFormValues>();
  const { type } = useQueryParams<{ type?: SendOptionType }>();
  const { isMobile } = useWindowSize();

  const queryHook = type ? queryHooks[type] : () => null;

  const queryReturn = queryHook({
    ...filter,
  });

  const items = flatInfiniteData(queryReturn?.data);

  const dataSource = items.map<CrmReceiverCustomer>(
    ({ customer, ...item }: CrmCustomerWithVehicleListResponse) => ({
      id: item.id,
      customer: customer,
      vehicle: item,
    }),
  );

  return (
    <>
      <CrmCustomerListFilter onFilter={setFilter} />

      <Divider />

      <ShippingOptionsCustomerTable
        dataSource={dataSource}
        loading={queryReturn?.isLoading}
        onCustomersSelected={onCustomersSelected}
        customerIds={customerIds}
        CustomersSelected={CustomersSelected}
        refetch={queryReturn?.refetch}
        fetchNextPage={queryReturn?.fetchNextPage}
        hasNextPage={queryReturn?.hasNextPage}
        isFetching={queryReturn?.isFetching}
      />

      <Row gutter={[24, 24]} style={{ marginTop: 24 }} justify="end">
        <Col span={isMobile ? 24 : undefined}>
          <Button onClick={onPrev} block>
            <AntdFeatherIcon icon={<ArrowLeft />} size={12} />
            <FormattedMessage id="commons.modal.button.back" />
          </Button>
        </Col>

        <Col span={isMobile ? 24 : undefined}>
          <Button htmlType="submit" block>
            <AntdFeatherIcon icon={<ArrowRight />} size={12} />
            <span>Continuar</span>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default CrmCustomersWithVehicleList;
